import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.user_session_ */
export type UserSessionSid = string & { __brand: 'UserSessionSid' }

/** Represents the table public.user_session_ */
export default interface UserSessionTable {
  /** Database type: pg_catalog.text */
  sid: ColumnType<UserSessionSid, UserSessionSid, UserSessionSid>

  /** Database type: pg_catalog.jsonb */
  sess: ColumnType<unknown, unknown, unknown>

  /** Database type: pg_catalog.timestamptz */
  expire: ColumnType<Date, Date | string, Date | string>
}

export type UserSession = Selectable<UserSessionTable>

export type UserSessionInitializer = Insertable<UserSessionTable>

export type UserSessionMutator = Updateable<UserSessionTable>

export const userSessionSid = z.string() as unknown as z.Schema<UserSessionSid>

export const userSession = z.object({
  sid: userSessionSid,
  sess: z.unknown(),
  expire: z.coerce.date(),
}) as unknown as z.Schema<UserSession>

export const userSessionInitializer = z.object({
  sid: userSessionSid,
  sess: z.unknown(),
  expire: z.coerce.date(),
}) as unknown as z.Schema<UserSessionInitializer>

export const userSessionMutator = z.object({
  sid: userSessionSid.optional(),
  sess: z.unknown().optional(),
  expire: z.coerce.date().optional(),
}) as unknown as z.Schema<UserSessionMutator>
